import proyecto from "../../api/Proyecto";

// Insertar una reparación nueva
export const insertarReparacion = async (data) => {
  const res = await proyecto.post("/reparaciones/batch", data);
  return res.data;
};


// Obtener todas las reparaciones (para seguimiento, lista, etc.)
export const getReparaciones = async () => {
  const res = await proyecto.get("/reparaciones");
  return res.data;
};

// Actualizar el estado de una reparación
export const actualizarEstadoReparacion = async (id, nuevoEstado) => {
  const res = await proyecto.put(`/reparaciones/${id}/estado`, { estado: nuevoEstado });
  return res.data;
};

// Obtener un listado de estados disponibles (opcional si tienes tabla de estados)
export const getEstadosReparacion = async () => {
  const res = await proyecto.get("/reparaciones/estados");
  return res.data;
};

// Obtener una reparación específica (para edición o detalle)
export const getReparacionById = async (id) => {
  const res = await proyecto.get(`/reparaciones/${id}`);
  return res.data;
};
